import { useTranslation } from "react-i18next";
import { ExamConfirmationDialog } from "./ExamConfirmationDialog";

interface ExitExamModalProps {
  onCancel?: () => void;
  onContinue?: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export default function ExitExamModal({
  onCancel = () => {},
  onContinue = () => {},
  onOpenChange,
  open,
}: ExitExamModalProps) {
  const { t } = useTranslation();

  return (
    <ExamConfirmationDialog
      body={t("test.exit_confirm_body_detailed")}
      cancelLabel={t("test.exit_go_back")}
      confirmLabel={t("test.exit_and_discard")}
      destructive
      onCancel={onCancel}
      onConfirm={onContinue}
      onOpenChange={onOpenChange}
      open={open}
      title={t("test.exit_confirm_title")}
    />
  );
}
